import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/zhenduan.png'
import _imports_1 from '@/assets/weixiu.png'
import _imports_2 from '@/assets/jiancha.png'
import _imports_3 from '@/assets/menxian.png'


const _hoisted_1 = { style: {"padding":"16px 16px","height":"calc(100vh - 100px)","background-color":"#080718ff","overflow-y":"scroll","padding-bottom":"30px","color":"#fff"} }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = {
  class: "w-full",
  style: {"border-bottom":"1px solid #ffc000"}
}
const _hoisted_4 = {
  class: "flex items-center px-5",
  style: {"font-size":"18px"}
}
const _hoisted_5 = { class: "event-btns" }
const _hoisted_6 = { class: "w-full p-5" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = {
  class: "box mt-4",
  style: {"width":"100%"}
}
const _hoisted_10 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "ml-2" }
const _hoisted_16 = {
  key: 2,
  class: "flex items-center"
}
const _hoisted_17 = { class: "ml-2" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { style: {"color":"#fff"} }
const _hoisted_25 = { class: "w-full flex" }
const _hoisted_26 = {
  class: "text-center w-full",
  style: {"font-size":"24px"}
}
const _hoisted_27 = { class: "w-full flex justify-center" }
const _hoisted_28 = { style: {"color":"#fff"} }
const _hoisted_29 = { class: "w-full flex" }
const _hoisted_30 = {
  class: "text-center w-full",
  style: {"font-size":"24px"}
}
const _hoisted_31 = { class: "w-full flex justify-center" }
const _hoisted_32 = { style: {"color":"#fff"} }
const _hoisted_33 = { class: "w-full flex" }
const _hoisted_34 = {
  class: "text-center w-full",
  style: {"font-size":"24px"}
}

import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  watch,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import request from "../../common/request";
import {
  transformDate,
  transformDate2,
  getGroupListByFactory,
  getRealFactoryIdList,
  transformBeiJingDate, transformLocalDate
} from "../../common/tools";
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
import DownLoadComponent from "../components/downLoad.vue";
import { Dayjs } from "dayjs";
import { langList } from "../../common/lang";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import AlarmBeepConfig from "@/components/warning-manage/alarm-beep-config.vue";
import { getLanguage, getTranslation, getChineseFt } from "@/common/translate";


export default /*@__PURE__*/_defineComponent({
  __name: 'warning-list',
  setup(__props) {

let getDiagLang = (record) => {
  try {
    if (record.diagnosticNotes.includes('测点：')) {
      let arr = record.diagnosticNotes.split("；");
      if (arr.length > 1) {
        let s1 = arr[0].split("：");
        let s1_1 = getLanguage(s1[0]);
        let s1_2 = getTranslation(s1[1]);

        let s2 = arr[1].split("：");
        
        let s2str = getLanguage(s2[0])+'：'+s2[1].replace('超过1级阈值',getLanguage('超过1级阈值')).replace('超过2级阈值',getLanguage('超过2级阈值')).replace('超过3级阈值',getLanguage('超过3级阈值'))

        return s1_1 + "：" + s1_2 + "；"+s2str;
      } else {
        return record.diagnosticNotes
      }
    } else {
      let arr = record.diagnosticNotes.split("；").filter((p:any) => p)
      let strArr:any = []
      arr.map((d:any) => {
        let s1 = getTranslation(d.split("：")[0]);
        let s2 = d.split("：")[1]
        let s2L = s2.split("，").filter((p:any) => p)
        let s3L:any = []
        s2L.map((d:any) => {
          s3L.push(getLanguage(d)) 
        })
        let s3 = s3L.join("，")
        let s4 = s1 + "：" + s3;
        strArr.push(s4)
      })
      return strArr.join("；")
    }
  } catch (error) {
    console.log('error', error)
    return record.diagnosticNotes
  }
};

const router = useRouter();
const route = useRoute();
const getLang = () => {
  language.value = localStorage.getItem("language") || "English";
  langObj.value = langList[language.value];
};
let typeList = [
  { label: "智能诊断", value: 1 },
  // {label: 'Maintenance record', value: 2},
  // {label: 'Equipment inspection', value: 3},
  { label: "门限报警", value: 4 },
];
let langObj: any = ref({});
let language: any = ref("English");
getLang();

let conditionList = [
  { label: "健康", value: 0, color: "#61c08f" },
  { label: "可用", value: 1, color: "#706a00ff" },
  { label: "可用", value: 2, color: "#706a00ff" },
  { label: "警戒", value: 3, color: "#cd5f3b" },
  { label: "警戒", value: 4, color: "#cd5f3b" },
  { label: "警戒", value: 5, color: "#cd5f3b" },
  { label: "故障", value: 6, color: "#921e37" },
  { label: "故障", value: 7, color: "#921e37" },
];
let conditionList2 = [
  { label: "健康", value: 0, color: "#61c08f" },
  { label: "可用上", value: 1, color: "#706a00ff" },
  { label: "可用下", value: 2, color: "#706a00ff" },
  { label: "警戒上", value: 3, color: "#cd5f3b" },
  { label: "警戒中", value: 4, color: "#cd5f3b" },
  { label: "警戒下", value: 5, color: "#cd5f3b" },
  { label: "故障上", value: 6, color: "#921e37" },
  { label: "故障下", value: 7, color: "#921e37" },
];
let conditionLists = [
  { label: "健康", value: 1, real: [0] },
  { label: "可用", value: 2, real: [1, 2] },
  { label: "警戒", value: 3, real: [3, 4, 5] },
  { label: "故障", value: 4, real: [6, 7] },
];

let statusList = [
  { label: "未处理 ", value: 1 },
  { label: "已处理 ", value: 2 },
  { label: "已关闭 ", value: 3 },
];

let warningColumns = [
  {
    title: langObj.value["报警时间"],
    dataIndex: "date",
  },
  {
    title: langObj.value["报警类型"],
    dataIndex: "type",
  },
  {
    title: langObj.value["严重程度"],
    dataIndex: "condition",
  },
  {
    title: langObj.value["设备"],
    dataIndex: "machineName",
  },
  {
    title: langObj.value["报警内容"],
    dataIndex: "diagnosticNotes",
  },
  {
    title: langObj.value["联系人"],
    dataIndex: "contactName",
  },
  {
    title: getLanguage("处理状态"),
    dataIndex: "handleStatus",
  },
  {
    title: langObj.value["操作"],
    dataIndex: "act",
  },
];
const pagination = computed(() => ({
  total: searchModel.value.total,
  current: searchModel.value.skip,
  pageSize: searchModel.value.take,
}));
let data: any = ref([]);
let menuSelect: any = ref(1);
let searchModel: any = ref({
  groupId: null,
  machienId: null,
  date: null,
  skip: 1,
  take: 20,
  condition: [],
  handleStatus: null,
});
let selectedRowKeys: any = ref();
let groupList: any = ref([]);
let machineList: any = ref([]);
let visibledel = ref(false);
let formClose: any = ref({
  closeCause: "",
});
let isEditable: any = ref(false);
let isAdmin: any = ref(false);
let editVisible: any = ref(false);
let editForm: any = ref({});

onMounted(() => {
  isEditable.value = true;
  getAdmin();
  getCount();
  getGroupList();
  search();
  getLang();
  getHistory();
});

// Check whether there is a previous page
let isShowBack = ref(false);
const getHistory = () => {
  if (window?.history?.length > 0) {
    isShowBack.value = true;
  }
};

const getAdmin = () => {
  let memberInfo = JSON.parse(localStorage.getItem("memberInfo") || "{}");
  isAdmin.value = memberInfo?.admin;
};

let counts: any = ref({
  count0: 0,
  count1: 0,
  count2: 0,
  count3: 0,
});
// Get count statistics
const getCount = async () => {
  let config: any = {
    params: {
      factoryIds: getRealFactoryIdList(),
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  let result = await request.get("/api/workflows/count/pc", config);
  counts.value = result.data;
};

// Get area list
const getGroupList = () => {
  groupList.value = getGroupListByFactory();
};

// Select area
const selectGroup = (ev: any) => {
  let memberInfo = JSON.parse(localStorage.getItem("memberInfo") || "");
  searchModel.value.machienId = "";
  if (ev) {
    machineList.value = memberInfo.machines.filter(
      (p: any) => p.groupId === ev
    );
  } else {
    machineList.value = [];
  }
};

const search = () => {
  searchModel.value.skip = 1;
  getData();
};

const reset = () => {
  searchModel.value = {
    ...searchModel.value,
    groupId: null,
    machienId: null,
    date: null,
    type: null,
    condition: null,
  };
};

const getData = async () => {
  let config: any = {
    params: {
      skip: searchModel.value.skip,
      take: searchModel.value.take,
      machineId: searchModel.value.machienId,
      type: searchModel.value.type,
      handleStatus: searchModel.value.handleStatus,
      factoryIds: getRealFactoryIdList(),
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  if (!searchModel.value.type) {
    config.params.typeList = [1, 4];
  }

  if (searchModel.value.date && searchModel.value.date.length === 2) {
    config.params.begin = transformBeiJingDate(transformDate2(
      new Date(searchModel.value.date[0]),
      1
    ));
    config.params.end = transformBeiJingDate(transformDate2(new Date(searchModel.value.date[1]), 2));
  }

  if (searchModel.value.condition) {
    config.params.conditionList = conditionLists.find(
      (p: any) => p.value === searchModel.value.condition
    )?.real;
  }

  let result = await request.get("/api/workflows", config);

  if (result) {
    data.value = result.data.list;
    searchModel.value.total = result.data.total;
  }
};

const handleTableChange = (pagination: any, filters: any, sorter: any) => {
  // Handle pagination data
  if (Object.keys(sorter).length) {
    var order = sorter.order ? (sorter.order == "descend" ? -1 : 1) : 0;
    searchModel.value.sort = sorter.field;
    searchModel.value.order = order;
  }
  // Handle pagination data
  searchModel.value.skip = pagination.current;
  searchModel.value.take = pagination.pageSize;
  getData();
};

// Edit work order
const edit = (ev: any) => {
  editForm.value = {
    id: ev.id,
    diagnosticNotes: ev.diagnosticNotes,
    condition: ev.condition,
  };
  editVisible.value = true;
};

// Submit edit
const submitEdit = async () => {
  let result = await request.put("/api/workflows", editForm.value);
  if (result?.data) {
    message.success(getLanguage("操作成功"));
    editVisible.value = false;
    getData();
  }
};

// Checkbox selection
const onSelectChange = (ev: any) => {
  selectedRowKeys.value = ev;
};

// Close alarm
const closeWarning = () => {
  if (!selectedRowKeys.value) {
    message.warning(langObj.value["请选择报警"]);
    return;
  }

  let list = data.value.filter((p: any) =>
    selectedRowKeys.value.includes(p.id)
  );

  for (let d of list) {
    if (d.handleStatus && (d.handleStatus === 2 || d.handleStatus === 3)) {
      message.warning(langObj.value["请选择未处理的报警"]);
      return;
    }
  }

  formClose.value.closeCause = "";
  visibledel.value = true;
};

const submitClose = async () => {
  if (!formClose.value.closeCause) {
    message.warning(langObj.value["请填写关闭原因"]);
    return;
  }

  let form = {
    closeCause: formClose.value.closeCause,
    list: [],
  };

  let list = data.value.filter((p: any) =>
    selectedRowKeys.value.includes(p.id)
  );

  if (list && list.length) {
    form.list = list.map((d: any) => ({
      date: d.date,
      condition: d.condition,
      diagnosticNotes: d.diagnosticNotes,
      id: d.id,
    }));
  }

  let result = await request.post("/api/workflows/close", form);
  if (result && result.status == 200) {
    message.success("操作成功!");
    selectedRowKeys.value = [];
    visibledel.value = false;
    getCount();
    getData();
  } else {
    message.warning("操作失败");
  }
};

const selectMenu = (ev: any, value: any) => {
  menuSelect.value = ev;
  searchModel.value.handleStatus = value;
  searchModel.value.skip = 1;
  getCount();
  getData();
};

// View closed items
let visibledel2 = ref(false);
const viewClose = (ev: any) => {
  formClose.value.closeCause = ev.closeCause;
  formClose.value.operator = ev.operator;
  formClose.value.operateTime = ev.operateTime;
  visibledel2.value = true;
};

// View report
const viewReport = (ev: any) => {
  router.push("/report/list");
};

const getRowClassName = (record: any, index: any) => {
  // Set different class names based on the index
  return index % 2 === 0 ? "even-row" : "odd-row";
};

// Set alarm sound interval
let alarmBeepConfigVisible = ref(false);
const onClickSetAlarmBeep = () => {
  alarmBeepConfigVisible.value = true;
};

// Download alarm
let downLoadVisible = ref(false);
let downLoadList: any = ref([]);
const downLoad = async () => {
  let config: any = {
    params: {
      skip: 1,
      take: 100000,
      machineId: searchModel.value.machienId,
      type: searchModel.value.type,
      handleStatus: searchModel.value.handleStatus,
      factoryIds: getRealFactoryIdList(),
    },
    headers: {
      requestId: uuidv4(),
    },
  };
  if (!searchModel.value.type) {
    config.params.typeList = [1, 4];
  }
  if (searchModel.value.date && searchModel.value.date.length === 2) {
    config.params.begin = transformDate2(
      new Date(searchModel.value.date[0]),
      1
    );
    config.params.end = transformDate2(new Date(searchModel.value.date[1]), 2);
  }

  if (searchModel.value.condition) {
    config.params.conditionList = conditionLists.find(
      (p: any) => p.value === searchModel.value.condition
    )?.real;
  }

  let result = await request.get("/api/workflows", config);
  let list: any = [];
  if (result) {
    list = result.data.list;
  }
  list.map((d: any) => {
    d.machineName = getTranslation(d.machineName);
    if (language.value === "Chinese_ft") {
      d.diagnosticNotes = getChineseFt(d.diagnosticNotes);
    }
  });

  downLoadList.value = list;
  downLoadVisible.value = true;
};

const downLoadCancel = () => {
  downLoadVisible.value = false;
};

const dates = ref<any>();

const disabledDate = (current: Dayjs) => {
  if (!dates.value || (dates.value as any).length === 0) {
    return false;
  }
  const tooLate = dates.value[0] && current.diff(dates.value[0], "days") > 30;
  const tooEarly = dates.value[1] && dates.value[1].diff(current, "days") > 30;
  return tooEarly || tooLate;
};

const onCalendarChange = (val: any) => {
  dates.value = val;
};

// \返回上一级
const goBack = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_close_outlined = _resolveComponent("close-outlined")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: _unref(language) === 'English' ? _unref(enUS) : _unref(zhCN)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["py-3 cursor-pointer", { 'txt-select': _unref(menuSelect) === 1 }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (selectMenu(1, null)))
              }, _toDisplayString(_unref(langObj)["全部"]) + "(" + _toDisplayString(_unref(counts).count0) + ") ", 3),
              _createElementVNode("div", {
                class: _normalizeClass(["py-3 cursor-pointer ml-24", { 'txt-select': _unref(menuSelect) === 2 }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (selectMenu(2, 1)))
              }, _toDisplayString(_unref(langObj)["未处理"]) + "(" + _toDisplayString(_unref(counts).count1) + ") ", 3),
              _createElementVNode("div", {
                class: _normalizeClass(["py-3 cursor-pointer ml-24", { 'txt-select': _unref(menuSelect) === 3 }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (selectMenu(3, 2)))
              }, _toDisplayString(_unref(langObj)["已处理"]) + "(" + _toDisplayString(_unref(counts).count2) + ") ", 3),
              _createElementVNode("div", {
                class: _normalizeClass(["py-3 cursor-pointer ml-24", { 'txt-select': _unref(menuSelect) === 4 }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (selectMenu(4, 3)))
              }, _toDisplayString(_unref(langObj)["已关闭"]) + "(" + _toDisplayString(_unref(counts).count3) + ") ", 3),
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                (_unref(isShowBack))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      onClick: goBack
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getLanguage)("返回")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_form, {
                model: _unref(searchModel),
                name: "horizontal_login",
                layout: "inline",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: _unref(langObj)['设备区域'],
                    name: "groupId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _unref(searchModel).groupId,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchModel).groupId) = $event)),
                        style: {"width":"220px"},
                        placeholder: _unref(langObj)['请选择设备区域'],
                        onChange: selectGroup
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupList), (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: index,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getTranslation)(item.name)), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: _unref(langObj)['设备'],
                    name: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _unref(searchModel).machienId,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchModel).machienId) = $event)),
                        style: {"width":"220px"},
                        placeholder: _unref(langObj)['请选择设备'],
                        allowClear: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(machineList), (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: index,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getTranslation)(item.name)), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: _unref(langObj)['报警时间'],
                    name: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_range_picker, {
                        value: _unref(searchModel).date,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchModel).date) = $event)),
                        "disabled-date": disabledDate,
                        onCalendarChange: onCalendarChange
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: _unref(langObj)['报警类型'],
                    name: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _unref(searchModel).type,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchModel).type) = $event)),
                        style: {"width":"220px"},
                        allowClear: "",
                        placeholder: _unref(langObj)['请选择报警类型']
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeList), (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: index,
                              value: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(langObj)[item.label]), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: _unref(langObj)['严重程度'],
                    name: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _unref(searchModel).condition,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchModel).condition) = $event)),
                        style: {"width":"220px"},
                        allowClear: "",
                        placeholder: _unref(langObj)['请选择严重程度']
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conditionLists), (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: index,
                              value: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(langObj)[item.label]), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          onClick: reset,
                          class: "btn px-5 py-1 fff cursor-pointer ml-4"
                        }, _toDisplayString(_unref(langObj)["重置"]), 1),
                        _createElementVNode("div", {
                          onClick: search,
                          class: "btn px-5 py-1 fff cursor-pointer ml-4",
                          style: {"background-color":"#171325ff"}
                        }, _toDisplayString(_unref(langObj)["查询"]), 1),
                        _createElementVNode("div", {
                          onClick: downLoad,
                          class: "btn px-5 py-1 fff cursor-pointer ml-4",
                          style: {"background-color":"#171325ff"}
                        }, _toDisplayString(_unref(langObj)["下载报警"]), 1),
                        (_unref(isEditable))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: closeWarning,
                              class: "btn px-5 py-1 fff cursor-pointer ml-4",
                              style: {"background-color":"#171325ff"}
                            }, _toDisplayString(_unref(langObj)["关闭报警"]), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          onClick: onClickSetAlarmBeep,
                          class: "btn px-5 py-1 fff cursor-pointer ml-4",
                          style: {"background-color":"#171325ff"}
                        }, _toDisplayString(_unref(getLanguage)("设置报警声音间隔")), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_table, {
                style: {"width":"100%"},
                size: "small",
                "row-class-name": getRowClassName,
                columns: _unref(warningColumns),
                "data-source": _unref(data),
                "row-selection": {
                selectedRowKeys: _unref(selectedRowKeys),
                onChange: onSelectChange,
              },
                pagination: pagination.value,
                onChange: handleTableChange,
                rowKey: "id"
              }, {
                bodyCell: _withCtx(({ column, text, record }) => [
                  (column.dataIndex === 'machineName')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(getTranslation)(text)), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'type')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (text === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[25] || (_cache[25] = [
                              _createElementVNode("img", {
                                style: {"width":"20px"},
                                src: _imports_0,
                                alt: ""
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        (text === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[26] || (_cache[26] = [
                              _createElementVNode("img", {
                                style: {"width":"20px"},
                                src: _imports_1,
                                alt: ""
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        (text === 3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[27] || (_cache[27] = [
                              _createElementVNode("img", {
                                style: {"width":"20px"},
                                src: _imports_2,
                                alt: ""
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        (text === 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[28] || (_cache[28] = [
                              _createElementVNode("img", {
                                style: {"width":"20px"},
                                src: _imports_3,
                                alt: ""
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(langObj)[_unref(typeList).find((p) => p.value === text)?.label]), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'condition')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", {
                          style: _normalizeStyle([{"width":"12px","height":"12px","border-radius":"50%"}, {
                        background: _unref(conditionList).find((p) => p.value === text)
                          ?.color,
                      }])
                        }, null, 4),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(langObj)[
                          _unref(conditionList).find((p) => p.value === text)?.label
                        ]), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'handleStatus')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (text === 3)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: ($event: any) => (viewClose(record))
                            }, [
                              _createElementVNode("a", null, _toDisplayString(_unref(langObj)["已关闭"]), 1)
                            ], 8, _hoisted_18))
                          : _createCommentVNode("", true),
                        (text !== 3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(statusList).find((p) => p.value === text)
                        ? _unref(langObj)[
                            _unref(statusList).find((p) => p.value === text).label
                          ]
                        : _unref(langObj)["未处理"]), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'diagnosticNotes')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        (_unref(language) == 'Chinese_ft')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(getChineseFt)(text)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(getDiagLang)(record) || text), 1))
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'date')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _createTextVNode(_toDisplayString(_unref(transformLocalDate)(text)), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'act')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        (_unref(isAdmin) && record.type == 1)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: ($event: any) => (edit(record))
                            }, _toDisplayString(_unref(langObj)["编辑"]), 9, _hoisted_22))
                          : _createCommentVNode("", true),
                        (_unref(isAdmin) && record.type == 1)
                          ? (_openBlock(), _createBlock(_component_a_divider, {
                              key: 1,
                              type: "vertical"
                            }))
                          : _createCommentVNode("", true),
                        (record.reportIds && record.reportIds.length)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              onClick: ($event: any) => (viewReport(record))
                            }, _toDisplayString(_unref(langObj)["查看报告"]), 9, _hoisted_23))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns", "data-source", "row-selection", "pagination"])
            ])
          ])
        ]),
        _createVNode(_component_a_modal, {
          visible: _unref(editVisible),
          "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => (_isRef(editVisible) ? (editVisible).value = $event : editVisible = $event)),
          closable: false,
          footer: null,
          bodyStyle: { background: '#080718ff' },
          style: {"top":"30%"},
          width: "1200px",
          maskClosable: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                _createElementVNode("div", {
                  class: "cursor-pointer",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_isRef(editVisible) //@ts-ignore
 ? editVisible.value = false : editVisible = false))
                }, [
                  _createVNode(_component_close_outlined, { style: {"font-size":"20px"} })
                ])
              ]),
              _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(langObj)["编辑"]), 1),
              _createVNode(_component_a_form, {
                ref: "formRef",
                name: "advanced_search",
                class: "ant-advanced-search-form",
                style: {"margin-top":"20px"},
                model: _unref(editForm)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    name: "condition",
                    label: _unref(getLanguage)('稳定状态'),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _unref(editForm).condition,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(editForm).condition) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conditionList2), (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: index,
                              value: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)(item.label)), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    name: "diagnosticNotes",
                    label: _unref(getLanguage)('报警内容'),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: _unref(editForm).diagnosticNotes,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(editForm).diagnosticNotes) = $event)),
                        placeholder: "",
                        rows: 4
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", {
                  onClick: submitEdit,
                  style: {"background-color":"#171325ff","padding":"5px 10px","width":"100px","font-size":"20px","text-align":"center","cursor":"pointer"}
                }, _toDisplayString(_unref(langObj)["提交"]), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_a_modal, {
          visible: _unref(visibledel),
          "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => (_isRef(visibledel) ? (visibledel).value = $event : visibledel = $event)),
          closable: false,
          footer: null,
          bodyStyle: { background: '#080718ff' },
          style: {"top":"30%"},
          width: "1200px",
          maskClosable: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                _createElementVNode("div", {
                  class: "cursor-pointer",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_isRef(visibledel) //@ts-ignore
 ? visibledel.value = false : visibledel = false))
                }, [
                  _createVNode(_component_close_outlined, { style: {"font-size":"20px"} })
                ])
              ]),
              _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(getLanguage)("关闭报警")), 1),
              _createVNode(_component_a_form, {
                ref: "formRef",
                name: "advanced_search",
                class: "ant-advanced-search-form",
                style: {"margin-top":"20px"},
                model: _unref(formClose)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { gutter: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            name: "closeCause",
                            label: _unref(langObj)['关闭原因'],
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_textarea, {
                                value: _unref(formClose).closeCause,
                                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_unref(formClose).closeCause) = $event)),
                                placeholder: "",
                                rows: 4
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", {
                  onClick: submitClose,
                  style: {"background-color":"#171325ff","padding":"5px 10px","width":"100px","font-size":"20px","text-align":"center","cursor":"pointer"}
                }, _toDisplayString(_unref(langObj)["提交"]), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_a_modal, {
          visible: _unref(visibledel2),
          "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => (_isRef(visibledel2) ? (visibledel2).value = $event : visibledel2 = $event)),
          closable: false,
          footer: null,
          bodyStyle: { background: '#080718ff' },
          style: {"top":"30%"},
          width: "1200px",
          maskClosable: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                _createElementVNode("div", {
                  class: "cursor-pointer",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_isRef(visibledel2) //@ts-ignore
 ? visibledel2.value = false : visibledel2 = false))
                }, [
                  _createVNode(_component_close_outlined, { style: {"font-size":"20px","color":"#fff !important"} })
                ])
              ]),
              _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(langObj)["关闭报警"]), 1),
              _createVNode(_component_a_form, {
                ref: "formRef",
                name: "advanced_search",
                class: "ant-advanced-search-form",
                style: {"margin-top":"20px"},
                model: _unref(formClose)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { gutter: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            name: "operator",
                            label: _unref(getLanguage)('操 作 人'),
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _unref(formClose).operator,
                                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_unref(formClose).operator) = $event)),
                                readonly: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_a_form_item, {
                            name: "operateTime",
                            label: _unref(getLanguage)('操作时间'),
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _unref(formClose).operateTime,
                                "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_unref(formClose).operateTime) = $event)),
                                readonly: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_a_form_item, {
                            name: "closeCause",
                            label: _unref(getLanguage)('关闭原因'),
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_textarea, {
                                value: _unref(formClose).closeCause,
                                "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_unref(formClose).closeCause) = $event)),
                                placeholder: "",
                                rows: 4,
                                readonly: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_a_modal, {
          width: 1400,
          visible: _unref(downLoadVisible),
          "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => (_isRef(downLoadVisible) ? (downLoadVisible).value = $event : downLoadVisible = $event)),
          title: _unref(langObj)['下载'],
          maskClosable: false,
          footer: false
        }, {
          default: _withCtx(() => [
            _createVNode(DownLoadComponent, {
              onDownLoadCancel: downLoadCancel,
              type: 2,
              dataList: _unref(downLoadList)
            }, null, 8, ["dataList"])
          ]),
          _: 1
        }, 8, ["visible", "title"]),
        _createVNode(_component_a_modal, {
          width: 1000,
          visible: _unref(alarmBeepConfigVisible),
          "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => (_isRef(alarmBeepConfigVisible) ? (alarmBeepConfigVisible).value = $event : alarmBeepConfigVisible = $event)),
          title: _unref(getLanguage)('设置报警声音间隔'),
          maskClosable: false,
          footer: false
        }, {
          default: _withCtx(() => [
            _createVNode(AlarmBeepConfig, {
              onSuccess: _cache[22] || (_cache[22] = ($event: any) => (_isRef(alarmBeepConfigVisible) //@ts-ignore
 ? alarmBeepConfigVisible.value = false : alarmBeepConfigVisible = false))
            })
          ]),
          _: 1
        }, 8, ["visible", "title"])
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})